export enum UserRole {
    ADMIN = 'ADMIN',
    ORG_ADMIN = 'ORG_ADMIN',
    USER = 'USER'
}

export const getUserRoles = (): UserRole[] => {
    return [UserRole.ORG_ADMIN, UserRole.USER];
}
